import type { GatewayUserSettings } from '@/core/utils/interfaces/gatewayUserSettings.interface'
import { isValidGatewayPort } from '@/core/utils/isValidGatewayPort'

import type { GatewaySettingsFormErrors } from '../interfaces/gatewaySettingsFormErrors.interface'

export function validateGatewaySettingsForm(settings: GatewayUserSettings): GatewaySettingsFormErrors {
  const errors: GatewaySettingsFormErrors = {}

  if (!settings.host?.trim()) {
    errors.host = 'Host is required'
  }

  if (!settings.httpPort?.trim() || !isValidGatewayPort(settings.httpPort)) {
    errors.httpPort = 'Enter a valid HTTP port (1-65535)'
  }

  if (settings.wsPort?.trim() && !isValidGatewayPort(settings.wsPort)) {
    errors.wsPort = 'Enter a valid WebSocket port (1-65535)'
  }

  if (settings.mcpPort?.trim() && !isValidGatewayPort(settings.mcpPort)) {
    errors.mcpPort = 'Enter a valid MCP port (1-65535)'
  }

  return errors
}
